export default "__VITE_ASSET__384135e7__"